export default "__VITE_ASSET__CITZzWXB__"